import React, { useState, useEffect } from 'react';
import ImageGrid from '../components/ImageGrid';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, CardMedia, Typography, Box, Button, Switch, FormControlLabel, styled, TextField, Checkbox } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import Check from '@mui/icons-material/Check';
import TheatersIcon from '@mui/icons-material/Theaters';
import AdminProductView from '../components/AdminProductView';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import CloseIcon from '@mui/icons-material/Close';

import Sidebar from '../components/Sidebar';
import ImageGalleryWithCarusel from '../components/ImageGalleryWithCarusel';
import config from '../config';
import FurnitureViewer from '../components/FurnitureViewer';
import Snackbar from '@mui/material/Snackbar';

const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
  height: '100%',
});

const ButtonWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  marginLeft: "0",
  marginBottom: theme.spacing(5),
  marginTop: 'auto',
  display: 'flex',
  justifyContent: 'center',
}));

const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
});

const ReviewPageHeader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  alignContent: 'start',
  width: '100%',
});

const Header = styled('h1')(({ theme }) => ({
  fontSize: '1.65rem',
  fontWeight: 'normal',
  fontFamily: theme.typography.fontFamily,
  color: '#2E2E2E',
  paddingTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const InProgressContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  paddingBottom: '15px',
  fontSize: '1.65rem',
  fontWeight: 'normal',
  fontFamily: theme.typography.fontFamily,
  color: '#2E2E2E',
}));

const FileLinkContainer = styled('div')(({ theme }) => ({
  alignContent: 'center',
  cursor: 'pointer',
  zIndex: 1,
  '&:hover': {
    color: 'blue',
    textDecorationColor: 'blue',
  },
  color: 'rgba(0, 0, 220, 0.8)',
  textDecorationColor: 'rgba(0, 0, 220, 0.8)',
  textDecoration: 'underline',
}));

const InfoContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  columnGap: theme.spacing(2),
  gridTemplateColumns: '1fr 1fr',
  paddingBottom: theme.spacing(2),
}));

const InfoContainerFiledKey = styled('p')(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  fontFamily: theme.typography.infoKey.fontFamily,
  fontWeight: theme.typography.infoKey.fontWeight,
  color: theme.typography.infoKey.color,
  fontSize: '1rem',
}));

const InfoContainerFiledValue = styled('p')(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  fontFamily: theme.typography.infoValue.fontFamily,
  color: theme.typography.infoValue.color,
  fontWeight: theme.typography.infoValue.fontWeight,
  fontSize: '1rem',
}));

const CheckValue = styled('span')(({ theme, value }) => ({
  color: value > 2.5 ? 'red' : theme.typography.infoValue.color,
}));

const TopRowContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
});


const QAModeContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: "flex-start",
});

const ReviewPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);


  const sessionId = queryParams.get('session_id');

  const [renderStatus, setRenderStatus] = useState('in_progress');
  const [images, setImages] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [wristSize, setWristSize] = useState(0);
  const [productFileUrl, setproductFileUrl] = useState(null);
  const [productFileName, setProductFileName] = useState(null);
  const [evaluationMode, setEvaluationMode] = useState(false);
  const [productTitle, setProductTitle] = useState('');
  const [timeSessionCreated, setTimeSessionCreated] = useState(null);
  const [timeInProgress, setTimeInProgress] = useState(null);
  const [sessionQAStatus, setSessionQAStatus] = useState(null);
  const [category, setCategory] = useState(null);
  const [usdzFileUrl, setUsdzFileUrl] = useState(null);
  const [usdzFileName, setUsdzFileName] = useState(null);
  const [productId, setProductId] = useState(null);
  const [adminProductUrl, setAdminProductUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [productFileSize, setProductFileSize] = useState(null);
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const [depth, setDepth] = useState(null);
  const [usdzFileSize, setUsdzFileSize] = useState(null);

  const [approveWithoutId, setApproveWithoutId] = useState(false);

  const [productInfo, setProductInfo] = useState(null);
  const [showReloadNotification, setShowReloadNotification] = useState(false);
  const [autoReloadStatus, setAutoReloadStatus] = useState(null);

  useEffect(() => {
    fetchSessionStatus(sessionId)
      .then(response_data => {
        setErrorMessage(null);
        setRenderStatus(response_data[0]);
        setImages(response_data[1]);
        setWristSize(response_data[2]);
        setproductFileUrl(response_data[3]);
        setProductFileName(response_data[3].split('/').pop());
        setTimeSessionCreated(response_data[4]);
        setProductTitle(response_data[5]);
        setProductId(response_data[8]);
        updateProductInfo(response_data[8]);

        let category = response_data[5].split(' ')[0];
        category = category.slice(0, -1);
        setCategory(category);

        setSessionQAStatus(response_data[6]);
        if (category === 'Furniture') {
          setUsdzFileUrl(response_data[7])
          setUsdzFileName(response_data[7].split('/').pop());
          setProductId(response_data[8]);
          setAdminProductUrl(`https://yrulermgr.triplenext.net/Admin/CompareBag/EditBag/${response_data[8]}`);
          setWidth(response_data[9]);
          setHeight(response_data[10]);
          setDepth(response_data[11]);
          setProductFileSize(response_data[12])
          setUsdzFileSize(response_data[13])
        }
      })
      .catch(error => {
        setErrorMessage(error.message);
      });
  }, []);

  // Periodic status check
  useEffect(() => {
    if (!sessionId || renderStatus === 'completed' || renderStatus === 'failed') return;
    const interval = setInterval(async () => {
      try {
        const resp = await fetch(`${config.serverUrl}/session-status/${sessionId}`);
        if (resp.status === 200) {
          const data = await resp.json();
          if (data.status === 'completed') {
            setShowReloadNotification(true);
            setAutoReloadStatus('completed');
            // Show notification via Notification API if permission is granted
            if (window.Notification && Notification.permission === 'granted') {
              new Notification('Render completed!', {
                body: 'Please refresh the page to see the results.',
                tag: 'render-status',
                requireInteraction: true
              });
            }
          }
          if (data.status === 'failed') {
            setShowReloadNotification(true);
            setAutoReloadStatus('failed');
            if (window.Notification && Notification.permission === 'granted') {
              new Notification('Render failed', {
                body: 'Refresh the page for details.',
                tag: 'render-status',
                requireInteraction: true
              });
            }
          }
        }
      } catch (e) {
        // ignore
      }
    }, 10000);
    return () => clearInterval(interval);
  }, [sessionId, renderStatus]);

  // Request notification permission on mount
  useEffect(() => {
    if (window.Notification && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    const timeCreatedAsInt = parseInt(timeSessionCreated);
    const timeCreated = new Date(timeCreatedAsInt * 1000);
    const currentTime = new Date()
    const timeDiff = currentTime - timeCreated;
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
    setTimeInProgress(`${hours}h ${minutes}m ${seconds}s`);
  }, [timeSessionCreated]);


  useEffect(() => {
    if (productFileName && sessionId) {
      document.title = `${productTitle} | ${sessionId}`;
    }
  }, [productFileName]);

  // Change title and favicon when render is completed
  useEffect(() => {
    if (autoReloadStatus === 'completed') {
      document.title = `Done! ${productTitle}`;
      // Change favicon to green
      const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/svg+xml';
      link.href = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="%2300c853"/><text x="16" y="22" font-size="18" text-anchor="middle" fill="white" font-family="Arial" font-weight="bold">✔</text></svg>';
      document.head.appendChild(link);
    } else if (autoReloadStatus !== 'completed') {
      document.title = productFileName && sessionId ? `${productTitle} | ${sessionId}` : document.title;
      // Restore default favicon
      const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.href = '/favicon.ico';
      document.head.appendChild(link);
    }
  }, [autoReloadStatus, productTitle, productFileName, sessionId]);

  const fetchSessionStatus = async sessionId => {
    const response = await fetch(`${config.serverUrl}/session/${sessionId}`);
    const data = await response.json();
    if (response.status == 404) {
      throw new Error('Session not found, please double check the URL');
    } else if (response.status != 200) {
      throw new Error(`Something went wrong, please try again later, ${data.message}`);
    }

    const status = data.status;
    const urls = data.files.map(url => `${config.serverUrl}/${url}`);
    const wristSize = data.wrist_size;
    const productFile = data.product_file?.includes("renders")
      ? `${config.serverUrl}/${data.product_file}`
      : `${data.product_file}`;
    const timeCreated = data.time_created;
    const productTitle = data.product_title;
    const qaStatus = data.qa_status;

    const productId = data.product_id;
    const usdzFile = `${config.serverUrl}/${data.usdz_file}`;
    const width = data.width;
    const height = data.height;
    const depth = data.depth;
    const productFileSize = data.product_file_size;
    const usdzFileSize = data.usdz_file_size

    return [status, urls, wristSize, productFile, timeCreated, productTitle, qaStatus, usdzFile, productId,
      width, height, depth, productFileSize, usdzFileSize];
  };

  const approveProduct = async () => {
    const userConfirmed = window.confirm("Are you sure you want to approve this product?");
    if (!userConfirmed) {
      return;
    }
    // bock the button until the request is done
    setIsLoading(true);

    let data_post = {};

    if (productId != null) {
      data_post = { 'product_id': productId };
    }
    if (wristSize != null) {
      data_post['wrist_size'] = wristSize;
    }

    const response = await fetch(`${config.serverUrl}/session/${sessionId}/approve/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data_post),
    });

    const data = await response.json();
    if (response.status == 404) {
      throw new Error('Session not found, please double check the URL');
    } else if (response.status != 200) {
      throw new Error(`Something went wrong, please try again later, ${data.message}`);
    }
    setIsLoading(false);

    setSessionQAStatus('approved');
  }

  const rejectProduct = async () => {
    const response = await fetch(`${config.serverUrl}/session/${sessionId}/reject`, {
      method: 'POST',
    });
    const data = await response.json();
    if (response.status == 404) {
      throw new Error('Session not found, please double check the URL');
    } else if (response.status != 200) {
      throw new Error(`Something went wrong, please try again later, ${data.message}`);
    }

    setSessionQAStatus('rejected');
  }

  const updateProductInfo = async (id) => {
    if (id == null || id == '') {
      setProductInfo(null);
      return;
    }
    const response = await fetch(`${config.serverUrl}/products/${id}`, {
      method: 'GET',
    });
    const data = await response.json();
    if (response.status == 200 && data != null) {
      setProductId(data.id);
      setProductInfo(data);
    }
    else {
      setProductId(null);
      setProductInfo(null);
    }
  }
  const handleChange = (event) => {
    setApproveWithoutId(event.target.checked);
  };

  return (
    <PageContainer>
      <Sidebar navigate={navigate} />
      <ContentContainer>
        <ReviewPageHeader>
          <TopRowContainer>
            <Header>{productTitle}</Header>
            <FormControlLabel control={<Switch onChange={() => setEvaluationMode(!evaluationMode)} />} label="QA mode" />
          </TopRowContainer>
          {errorMessage && <div>{errorMessage}</div>}
          <InfoContainer>
            <InfoContainerFiledKey>session id:</InfoContainerFiledKey>
            <InfoContainerFiledValue>{sessionId}</InfoContainerFiledValue>
            {category !== 'Furniture' && <InfoContainerFiledKey>wrist size:</InfoContainerFiledKey>}
            {category !== 'Furniture' && <InfoContainerFiledValue>{wristSize} mm</InfoContainerFiledValue>}
            {category === 'Furniture' && <InfoContainerFiledKey>model (glb):</InfoContainerFiledKey>}
            {category !== 'Furniture' && <InfoContainerFiledKey>model:</InfoContainerFiledKey>}
            <FileLinkContainer><a href={productFileUrl} target="_blank">{productFileName}</a> </FileLinkContainer>

            {category === 'Furniture' && <InfoContainerFiledKey>model (usdz):</InfoContainerFiledKey>}
            {category === 'Furniture' && <FileLinkContainer><a href={usdzFileUrl} target="_blank">{usdzFileName} </a></FileLinkContainer>}

            {category === 'Furniture' && <InfoContainerFiledKey>product id:</InfoContainerFiledKey>}
            {category === 'Furniture' && <FileLinkContainer><a href={adminProductUrl} target="_blank">{productId}</a></FileLinkContainer>}
            {category === 'Furniture' && <InfoContainerFiledKey>glb model size (width x depth x height): </InfoContainerFiledKey>}
            {category === 'Furniture' && <InfoContainerFiledValue>{width} mm x {depth} mm x {height} mm</InfoContainerFiledValue>}
            {category === 'Furniture' && <InfoContainerFiledKey>model size:</InfoContainerFiledKey>}
            {category === 'Furniture' && <InfoContainerFiledValue>glb:
              <CheckValue value={productFileSize}> {productFileSize} MB </CheckValue>; usdz:
              <CheckValue value={usdzFileSize}> {usdzFileSize} MB </CheckValue></InfoContainerFiledValue>}            {category === 'Furniture' && <InfoContainerFiledKey>model size:</InfoContainerFiledKey>}
            {category === 'Furniture' && <InfoContainerFiledValue>glb:
              <CheckValue value={productFileSize}> {productFileSize} MB </CheckValue>; usdz:
              <CheckValue value={usdzFileSize}> {usdzFileSize} MB </CheckValue></InfoContainerFiledValue>}
            <InfoContainerFiledKey>QA status:</InfoContainerFiledKey>
            <InfoContainerFiledValue>{sessionQAStatus}</InfoContainerFiledValue>
          </InfoContainer>
        </ReviewPageHeader>


        {renderStatus === 'completed' && evaluationMode && category === 'Furniture' &&
          <QAModeContainer>
            <ButtonWrapper>
              <TextField
                label="Product ID"
                variant="outlined"
                onChange={(e) => updateProductInfo(e.target.value)}
                value={productId}
              />
              <Button
                onClick={() => approveProduct()}
                color="primary"
                startIcon={<Check />}
                disabled={sessionQAStatus === 'approved' || isLoading}
              >
                Approve
              </Button>
              <Button
                onClick={() => rejectProduct()}
                color="error"
                startIcon={<CloseIcon />}
                disabled={sessionQAStatus === 'rejected' || isLoading}
              >

                Reject
              </Button>
            </ButtonWrapper>
          </QAModeContainer>
        }
        {sessionQAStatus === 'approved' && productId &&
          <a href={`${config.appUrl}projections/${productId}`}>Projections</a>
        }

        {renderStatus === 'completed' && !evaluationMode && category !== 'Furniture' && <>
          <Grid container spacing={2}>
            {!productId &&
              <ImageGrid images={images} />
            }


            {
              productId &&
              <>
                <Grid item xs={8} md={8}>
                  <ImageGrid images={images} />
                </Grid>
                <Grid item xs={4} md={4} style={{ backgroundColor: '#e9e9e9' }}>
                  <AdminProductView productId={productId} />
                </Grid>
              </>

            }

          </Grid>
        </>}
        {renderStatus === 'completed' && category === 'Furniture' && <FurnitureViewer glbUrl={productFileUrl} usdzUrl={usdzFileUrl} productId={productId} />}


        {/* review part */}
        {renderStatus === 'completed' && evaluationMode && category !== 'Furniture' &&
          <QAModeContainer>
            <TextField
              label="Product ID"
              variant="outlined"
              onChange={(e) => updateProductInfo(e.target.value)}
              value={productId}
            />
            <ButtonWrapper>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={approveWithoutId}
                    onChange={handleChange}
                    color="primary"
                  />
                }
                label="Approve without ID"
              />

              {((productId != null && productId != '') || approveWithoutId) &&
                <>
                  <Button
                    onClick={() => approveProduct()}
                    color="primary"
                    startIcon={<Check />}
                    disabled={sessionQAStatus === 'approved' || isLoading}
                  >
                    Approve
                  </Button>

                  <Button
                    onClick={() => rejectProduct()}
                    color="error"
                    startIcon={<CloseIcon />}
                    disabled={sessionQAStatus === 'rejected' || isLoading}
                  >
                    Reject
                  </Button>
                </>
              }
            </ButtonWrapper>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <ImageGalleryWithCarusel images={images} />
              </Grid>
              <Grid item xs={12} md={6}>
                {productInfo && (
                  <Card sx={{ maxWidth: 500 }}>
                    <CardMedia
                      component="img"
                      image={productInfo.cover_url}
                      alt={productInfo.name}
                      sx={{
                        width: '100%',
                        maxWidth: 300,
                        height: 300,
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                    <Box mt={4} p={2}>
                      <Typography variant="h4">Product Info</Typography>
                      <Typography variant="body2">{productInfo.name}</Typography>
                      <Typography variant="body2">Id: {productInfo.id}</Typography>
                      <Typography variant="body2">extern_id: {productInfo.extern_id}</Typography>
                      <Typography variant="body2">{productInfo.external_id}</Typography>
                      <Typography variant="body2">{productInfo.retailer}</Typography>
                      <Typography variant="body2" color="textSecondary">{productInfo.retailer_domain}</Typography>
                    </Box>
                  </Card>
                )}
              </Grid>
            </Grid>


          </QAModeContainer>
        }

        {/* render in progress part */}
        {renderStatus === 'in_progress' && (
          <InProgressContainer>
            <p>Hold tight! Render is in progress ({timeInProgress})</p>
            <ButtonWrapper>
              <Button
                variant="contained"
                onClick={() => window.location.reload()}
                startIcon={<RefreshIcon />}
              >
                Refresh page
              </Button>
            </ButtonWrapper>
          </InProgressContainer>
        )}
        {renderStatus === 'failed' && <div>Render failed, please try again</div>}
      </ContentContainer>
      <Snackbar
        open={showReloadNotification}
        autoHideDuration={null}
        onClose={() => setShowReloadNotification(false)}
        message={
          autoReloadStatus === 'completed'
            ? 'Render completed! Please refresh the page.'
            : autoReloadStatus === 'failed'
              ? 'Render failed. Please refresh the page.'
              : ''
        }
        action={
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            Refresh
          </Button>
        }
      />
    </PageContainer>
  );
};

export default ReviewPage;
